import { graphql } from 'react-relay';

export default graphql`
  query CeoHomePage_Query($customUrl: String!) {
    viewer {
      id
      ...CeoHomePage_viewer @arguments(customUrl: $customUrl)
    }
  }
`;
